import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getSearchProduct } from "../../server/product";
import { IProduct } from "../../server/product";
import ProductCard from "../../components/ProductCard";
import { Skeleton } from "../../components/Skeleton";

interface CategoryChild {
  id: string;
  name: string;
}

interface ProductCategoryProps {
  id: string;
  name: string;
  children: CategoryChild[];
}

export default function ProductCategory({
  id,
  name,
  children,
}: ProductCategoryProps) {
  const [data, setData] = useState<IProduct[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) return;

    async function load() {
      setLoading(true);
      const body = {
        pageIndex: 1,
        pageSize: 10,
        orderBy: "",
        orderDirection: "",
        keyword: "",
        productCategoryIds: [id],
        brandIds: [],
        inventoryStatus: 0,
      };
      try {
        const res = await getSearchProduct(body);
        if (res?.data) setData(res.data ?? []);
      } catch (error) {
        console.error("Error load product category:", error);
      } finally {
        setLoading(false);
      }
    }

    load();
  }, [id]);

  if (loading) {
    return (
      <section className="relative px-4 py-10">
        <div className="mx-auto max-w-7xl space-y-4 rounded-3xl bg-white/70 p-6 shadow-lift ring-1 ring-slate-100">
          <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <div>
              <Skeleton className="h-4 w-24" />
              <Skeleton className="mt-2 h-6 w-48" />
            </div>
            <div className="flex flex-wrap gap-2">
              {Array.from({ length: 4 }).map((_, idx) => (
                <Skeleton key={idx} className="h-8 w-24 rounded-full" />
              ))}
            </div>
          </div>

          <div className="grid gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
            {Array.from({ length: 5 }).map((_, idx) => (
              <div key={idx} className="space-y-3 rounded-2xl border border-slate-100 bg-white p-3">
                <Skeleton className="h-36 w-full rounded-xl" />
                <Skeleton className="h-4 w-3/4" />
                <Skeleton className="h-4 w-1/2" />
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  if (data?.length > 0) {
    return (
      <section className="relative px-4 py-10">
        <div className="mx-auto max-w-7xl space-y-4 rounded-3xl bg-white/70 p-6 shadow-lift ring-1 ring-slate-100">
          <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <div>
              <p className="section-eyebrow">Danh mục</p>
              <h3 className="section-title">{name}</h3>
            </div>

            <div className="flex flex-wrap gap-2">
              {children?.map((item) => (
                <Link
                  key={item?.id}
                  title={item?.name}
                  to={`/danh-muc-san-pham?categoryIds=${encodeURIComponent(
                    item?.id
                  )}`}
                  className="chip"
                >
                  {item?.name}
                </Link>
              ))}
            </div>
          </div>

          <div className="grid gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
            {data?.map((item: any) => (
              <ProductCard key={item.id} item={item} />
            ))}
          </div>
        </div>
      </section>
    );
  }

  return <></>;
}
